import { render, staticRenderFns } from "./shopAutocomplete.vue?vue&type=template&id=f4bff7e0"
import script from "./shopAutocomplete.vue?vue&type=script&lang=js"
export * from "./shopAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports